(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["fit-finder"] && !Shopify.designMode) return;
  try {
    class FitFinder extends HTMLElement {
  connectedCallback() {
    this.input  = this.querySelector('.fit-finder__input');
    this.weight = this.querySelector('.fit-finder__weight');
    this.builds = this.querySelectorAll('.fit-finder__build-input');
    this.button = this.querySelector('.fit-finder__button');
    this.output = this.querySelector('.fit-finder__result');
    if (!this.input || !this.button || !this.output) return;

    this.ranges = this.parseChart(this.dataset.sizes || '');
    this.frames = this.parseFrames(this.dataset.frames || '');
    this.hMin = parseFloat(this.dataset.heightMin) || 0;
    this.hMax = parseFloat(this.dataset.heightMax) || 99;
    this.wMin = parseFloat(this.dataset.weightMin) || 0;
    this.wMax = parseFloat(this.dataset.weightMax) || 999;

    this.button.addEventListener('click', () => this.recommend());
    [this.input, this.weight].forEach((el) => {
      if (!el) return;
      el.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') { e.preventDefault(); this.recommend(); }
      });
    });
  }

  // label|hLo|hHi|size|default frame code
  parseChart(raw) {
    return raw.split('\n').map((line) => {
      const [label, min, max, friendly, def] = line.split('|').map((x) => (x || '').trim());
      const lo = parseFloat(min), hi = parseFloat(max);
      if (!label || Number.isNaN(lo) || Number.isNaN(hi)) return null;
      return { label, min: lo, max: hi, friendly: friendly || label, def: def || '' };
    }).filter(Boolean).sort((a, b) => a.min - b.min);
  }

  // code|name|frame|hLo|hHi|wLo|wHi|rank|wide - the supplier chart, and the
  // only thing that decides what we can physically build.
  parseFrames(raw) {
    return raw.split('\n').map((line) => {
      const p = line.split('|').map((x) => (x || '').trim());
      const [code, name, frame, hLo, hHi, wLo, wHi, rank, wide] = p;
      if (!code) return null;
      return {
        code, name, frame,
        hLo: parseFloat(hLo), hHi: parseFloat(hHi),
        wLo: parseFloat(wLo), wHi: parseFloat(wHi),
        rank: parseInt(rank, 10), wide: wide === '1',
      };
    }).filter(Boolean).sort((a, b) => a.rank - b.rank);
  }

  bandForHeight(height) {
    // Bands share endpoints, so treat them as half-open [min, max); the final
    // band keeps its upper bound inclusive.
    const last = this.ranges[this.ranges.length - 1];
    return this.ranges.find((r) =>
      height >= r.min && (height < r.max || (r === last && height <= r.max))) || null;
  }

  bandForLabel(label) {
    return this.ranges.find((r) => r.label === label) || null;
  }

  recommend() {
    const height = parseFloat(this.input.value);
    const weight = this.weight ? parseFloat(this.weight.value) : NaN;
    const picked = Array.from(this.builds || []).find((el) => el.checked) || null;
    const buildBand = picked ? picked.value : '';
    const buildName = picked ? (picked.dataset.name || '') : '';
    const buildClass = picked ? (picked.dataset.build || 'average') : '';

    const hasHeight = !Number.isNaN(height) && height > 0;
    const hasWeight = !Number.isNaN(weight) && weight > 0;

    if (!hasHeight && !buildBand) { this.flag(this.dataset.prompt); return; }

    // Out of range in either direction: we do not make that chair, so say so
    // rather than rounding them into the nearest frame.
    if (hasHeight && (height < this.hMin || height > this.hMax)) {
      this.flag(this.fill(this.dataset.unsupported, { value: this.fmtH(height) }));
      return;
    }
    if (hasWeight && (weight < this.wMin || weight > this.wMax)) {
      this.flag(this.fill(this.dataset.unsupported, { value: `${weight} lb` }));
      return;
    }

    let band = hasHeight ? this.bandForHeight(height) : this.bandForLabel(buildBand);
    if (!band) { this.flag(this.dataset.nomatch); return; }

    // Hierarchy, in order: height eliminates every frame that physically
    // cannot take it, weight ranks what survives, and build only breaks a
    // close call toward a wider or narrower frame. A build never invalidates a
    // measured height - mixes, sexes and measuring methods vary far too much.
    const frames = this.frames.filter((f) => height >= f.hLo && height <= f.hHi);
    let chosen = frames.find((f) => f.code === band.def) || frames[0] || null;

    if (hasHeight && !frames.length) {
      this.flag(this.fill(this.dataset.unsupported, { value: this.fmtH(height) }));
      return;
    }

    if (hasWeight && frames.length) {
      const fits = frames.filter((f) => weight >= f.wLo && weight <= f.wHi);
      const heaviest = Math.max(...frames.map((f) => f.wHi));
      if (weight > heaviest) {
        // Nothing this height can take physically is rated for that weight.
        this.flag(this.dataset.hip);
        return;
      }
      if (fits.length) {
        // Several frames are rated for it: lean wide for a stocky or giant
        // build, narrow for a slim one, smallest otherwise.
        chosen = buildClass === 'stocky' || buildClass === 'giant'
          ? fits[fits.length - 1]
          : fits[0];
      } else {
        // Between two reference ranges: take the nearest, and let the build
        // break the tie the same way.
        const distance = (f) => (weight < f.wLo ? f.wLo - weight : weight - f.wHi);
        const best = Math.min(...frames.map(distance));
        const near = frames.filter((f) => distance(f) === best);
        chosen = buildClass === 'stocky' || buildClass === 'giant'
          ? near[near.length - 1]
          : near[0];
      }

      // A stocky or giant dog at the top of its frame's range goes one wider,
      // where a wider frame exists for that height.
      if ((buildClass === 'stocky' || buildClass === 'giant')
          && weight >= (chosen.wLo + chosen.wHi) / 2) {
        const wider = frames.find((f) => f.rank === chosen.rank + 1);
        if (wider) chosen = wider;
      }
    }

    let note = '';
    if (chosen && chosen.code !== band.def) {
      const weightText = hasWeight ? `${weight} lb` : '';
      if (chosen.wide) {
        note = this.fill(this.dataset.wideNote, { value: weightText });
      } else if (chosen.rank > (this.frames.find((f) => f.code === band.def) || chosen).rank) {
        note = this.fill(this.dataset.stepNote, { value: weightText });
      } else {
        note = this.fill(this.dataset.downNote, { value: weightText });
      }
    }

    let basis;
    if (hasHeight && hasWeight) {
      basis = this.fill(this.dataset.basisWeight, { value: this.fmtH(height), weight: `${weight} lb` });
    } else if (hasHeight) {
      basis = this.fill(this.dataset.basisLabel, { value: this.fmtH(height) });
    } else {
      basis = this.fill(this.dataset.basisBuild, { build: buildName });
    }

    this.render(band, basis, note);
  }

  fmtH(value) {
    return `${value}${this.dataset.unit || '"'}`;
  }

  fill(template, values) {
    return Object.keys(values).reduce(
      (out, key) => out.split(`{${key}}`).join(values[key]),
      template || ''
    );
  }

  line(text, className) {
    const el = document.createElement('span');
    if (className) el.className = className;
    el.textContent = text;
    return el;
  }

  badge(glyph, flagged) {
    const el = document.createElement('span');
    el.className = 'fit-finder__tick';
    el.setAttribute('aria-hidden', 'true');
    el.textContent = glyph;
    return el;
  }

  // "Lead line | body copy". The lead is set like a result heading so the
  // customer reads what to do next before the explanation.
  flag(message) {
    this.output.hidden = false;
    this.output.className = 'fit-finder__result fit-finder__result--flag';
    this.output.replaceChildren();

    const parts = String(message || '').split('|').map((x) => x.trim()).filter(Boolean);
    const body = document.createElement('span');
    if (parts.length > 1) {
      body.append(this.line(parts[0], 'fit-finder__result-size'), document.createElement('br'));
      body.append(this.email(parts.slice(1).join(' ')));
    } else {
      body.append(this.email(parts[0] || ''));
    }
    this.output.append(this.badge('!', true), body);
  }

  // Any address in the copy becomes a mailto link, so "send us your
  // measurements" is one tap on a phone.
  email(text) {
    const span = document.createElement('span');
    span.className = 'fit-finder__result-basis';
    const match = /[\w.+-]+@[\w-]+\.[\w.-]+/.exec(text);
    if (!match) { span.textContent = text; return span; }
    const link = document.createElement('a');
    link.className = 'fit-finder__mail';
    link.href = `mailto:${match[0]}`;
    link.textContent = match[0];
    span.append(text.slice(0, match.index), link, text.slice(match.index + match[0].length));
    return span;
  }

  render(match, basis, note) {
    this.output.hidden = false;
    this.output.className = 'fit-finder__result';
    this.output.replaceChildren();

    const body = document.createElement('span');
    const parts = [
      this.line(this.dataset.resultLabel || 'Recommended fit:', ''),
      document.createElement('br'),
      this.line(`${match.friendly} (${match.label})`, 'fit-finder__result-size'),
      document.createElement('br'),
      this.line(basis, 'fit-finder__result-basis'),
    ];
    if (note) {
      parts.push(document.createElement('br'), this.line(note, 'fit-finder__result-basis'));
    }
    const pick = (this.dataset.selectNote || 'Select {size}, then {label}, above.')
      .split('{size}').join(match.friendly)
      .split('{label}').join(match.label);
    parts.push(document.createElement('br'), this.line(pick, 'fit-finder__result-basis'));

    body.append(...parts);
    this.output.append(this.badge('✓', false), body);
  }
}

if (!customElements.get('fit-finder')) {
  customElements.define('fit-finder', FitFinder);
}
  } catch(e) { console.error(e); }
})();

})();
